import React from "react";
import ContentCard from "../../../../UI/ContentCard/ContentCard";
import sustainImg from "../../../../assests/images/sustainability.png";

const VisionSustainability = () => (
  <ContentCard
    title="Care about sustainability"
    id="sustainable"
    image={sustainImg}
    imageTitle="Stop Overproduction"
    frontText="We believe that we have to stop the cycle of overproduction and  first listen to what people really want."
    backTextOne="We need to move towards true sustainable production cycles and organic materials. We believe in a humane and
        slave-free production process that enables people to evolve.

        The big  fashion industry nowadays produces fast fashion. With over 50 production cycles per year the industry
        wants to insure that there are always new products in the stores. But fast does not necessarily mean longlasting quality,
        nor does it guarantee to meet the style and taste of the individual customer.  Waste is created and this is often burned.
        The production circumstances of the fashion industry are highly questionable. Exhausted, low payed seamstresses,
        collapsed factory buildings, negative ecological impact ..."
    backTextTwo="We want to break this unreasonable chain of production by first finding the customer, letting them decide what they
        really want and then produce the perfect garment that promises longlasting quality."
  />
);

export default VisionSustainability;



// WEBPACK FOOTER //
// ./src/components/Pages/Vision/Content/VisionSustainability.js